// CheckoutDialog.jsx
//
// Opción A del mockup elegido (#1680): el mismo bloque de planes + país + pago
// dentro de un diálogo. Se abre desde la tarjeta de prueba gratuita
// (`SuscripcionGate`) y desde "Mi suscripción" (`ProfileView`); también al
// volver de Flow con `?pago=flow` (`RetornoPago`). Cubre R25, R31.
//
// fullScreen en mobile. zIndex 20001: la pantalla de bloqueo del gate vive en
// 20000 y el retorno de Flow se abre ENCIMA de ella, no detrás.
import { Dialog, DialogContent, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PlanesYPago from "./PlanesYPago";

const CheckoutDialog = ({ open, onClose, faseInicial = "planes", rielInicial = "flow" }) => {
  const theme = useTheme();
  const pantallaCompleta = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={pantallaCompleta}
      maxWidth="xs"
      fullWidth
      aria-label="Elegir plan"
      sx={{ zIndex: 20001 }}
      PaperProps={{
        sx: {
          backgroundColor: "var(--bg-elevated)",
          backgroundImage: "none",
          border: pantallaCompleta ? 0 : "1px solid var(--border-soft)",
          borderRadius: pantallaCompleta ? 0 : "16px",
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 2.5, sm: 3 } }}>
        <PlanesYPago
          faseInicial={faseInicial}
          rielInicial={rielInicial}
          onVolver={onClose}
          onListo={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CheckoutDialog;
